import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
} from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';

import Select from 'react-select';

import MyPagination from 'Components/MyPagination'
import dayjs from 'dayjs';
import * as XLSX from 'xlsx'

import Footer from 'Components/Footer';
import TabsIcon from 'MiddleSystems/Components/layout/TabsIcon';
import ReportImage from 'assets/icon/report-menu.png'
import Back from 'assets/icon/back.png';
// image
import CALENDAR from 'assets/icon/Calendar.png';

import { useDispatch, useSelector } from 'react-redux';
//API
import { loadAuth } from 'actions/auth';
import { LoadCustomerServiceList } from 'actions/reports/index'

import { DatePicker } from 'antd';
import moment from 'moment';
import numeral from 'numeral';


export default function Stock() {
  const history = useHistory();
  const dispatch = useDispatch();

  const permission = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : null;
  const { log_permissions } = useSelector( (state) => state.user.permissions)
  const report_permission = log_permissions.find(item => item.permission.name === 'รายงาน' && item.middle === permission.middle)

  const { RangePicker } = DatePicker;

  const [Search, setSearch] = useState({
    Date: [
      moment(),
      moment()
    ],
    PerPage: 10,
    CurrentPage: 1,
    Rows: 0,
    Type: '',

  })

  const getAuth = async () => {
    try {
      const params = {
        name: ['รายการการใช้บริการของลูกค้า'],
        permission : 'view',
      }
      const response = await dispatch(loadAuth(params));
      if(response.data.data === 'Unauthorized'){
        alert(response.data.message)
        history.push('/report');
      }
    } catch (error) {
      history.push('/report');
      console.error(error);
    }
  };

  const [errors, setErrors] = useState([]);
  const ExportExcel = () => {
    const params = {
      start_date: moment(Search?.Date[0]).format('YYYY-MM-DD'),
      end_date: moment(Search?.Date[1]).format('YYYY-MM-DD'),
      page: 1,
      status: Search.Type,
    }

    dispatch(LoadCustomerServiceList(params)).then(response => {
      if (response.data.data && !response.data.data.length) {
        setErrors(['ไม่พบการนัดหมายที่เลือก'])
        return false
      }
      let data = [];
      let export_name = [];
      response.data.data.map( (item, key) => {
        let set = {
          'ลำดับ': key + 1 ,
          // 'วันที่': dayjs(item.created_at).format('DD/MM/YYYY'),
          // 'เลขที่ Job': item.job_detail?.job?.job_code,
          'วันรับบริการ': `${moment(item.created_at).format('YYYY-MM-DD')}`,
          'เลขที่ JOB': `${item.job.job_code}`,
          'เลขที่บิล': `${ item?.job.bill?.bill_code}`,
          'รายการ': `${item?.package?.name}`,
          'จำนวนเงิน': `${numeral(item.job.total_price).format('0,0.00')}`,
          'รับประกัน': `${item.package.warranty_period !== null ? CallWarrantyPeriod(item.created_at, item.package.warranty_period) : '-'}`,
          'สถานะประกัน': `${item.package.warranty_period !== null ? StatusWarrantyPeriod(item.created_at, item.package.warranty_period) : '-'}`,
        }
        export_name = `CustomerServiceList - ${dayjs(item.created_at).format('DD-MM-YYYY')} `

        data.push(set);
      })
      const dataWS = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, export_name + '.xlsx')
    }).catch(e => {
      setErrors(['เกิดข้อผิดพลาด'])
    })
  }

  const [Loading,setLoading] = useState(false);

  const [ReportStock,setReportStock] = useState([])

  const [Pages, setPage] = useState([
    { value: null, label: 'ทั้งหมด' },
    { value: 10, label: '10' },
    { value: 15, label: '15' },
  ]);


  const getReportStock = async () => {
    try {
      const params = {
        start_date: moment(Search?.Date[0]).format('YYYY-MM-DD'),
        end_date: moment(Search?.Date[1]).format('YYYY-MM-DD'),
        limit: Search.PerPage,
        page: Search.CurrentPage,
        status: Search.Type,
      };
      const response = await dispatch(LoadCustomerServiceList(params));
      if(Search.PerPage > 0){
        setReportStock(response.data.data.data);
        setSearch({ ...Search, 
          Rows: response.data.data.last_page,
          CurrentPage: response.data.data.current_page 
        })
        setLoading(false);
      }else{
        setReportStock(response.data.data);
        setSearch({ ...Search, 
          Rows: 0,
          CurrentPage: 1 
        })
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  }


  useEffect( () =>{
    getAuth()
    getReportStock();
  },[Search.Date,Search.PerPage,Search.CurrentPage,Search.Type]);

  function close() {
    history.push(`/report`);
  }

	function CallWarrantyPeriod(day, num) {
		let wp = dayjs(day).add(num, 'year');
		let time = dayjs().valueOf();
		let wp_time = dayjs(day).valueOf();
		let diffday = dayjs().diff(wp, 'day');

		if(wp_time - time <= 0){
			diffday = diffday * -1;
		}

		return dayjs(wp).format('DD/MM/YYYY') + ' (' + diffday + ' วัน)'

	}

	function StatusWarrantyPeriod(day, num) {
		let wp = dayjs(day).add(num, 'year');
		let time = dayjs().valueOf();
		let wp_time = dayjs(wp).valueOf();

		if(wp_time - time <= 0){
			return 'หมดอายุประกัน';
		}else{
			return 'อยู่ในอายุประกัน';
		}

	}

  return (
    <>
      <Container
        fluid
        className="package-container Service Stock Bill Report bg-mrk"
      >
        <div className="package">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={ReportImage} />
                  <b>
                      <Link to={`/report`} className='mr-2'>รายงาน</Link>
                      &gt; รายการการใช้บริการของลูกค้า
                    </b>
                </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={close}
                  >
                    <span aria-hidden="true">X</span>
                  </button>
              </div>
              <div className="modal-header-mobile">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={close}
                >
                  <img src={Back} />
                </button>
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={ReportImage} />
                  <b>
                      <Link to={`/report`} className='mr-2'>รายงาน</Link>
                      &gt; รายการการใช้บริการของลูกค้า
                    </b>
                </h5>
              </div>
              <div className="modal-body">
                <Row className="g-0 tabsicon justify-content-center ">
                  <TabsIcon />
                </Row>
                <Row className="g-0">
                  <Col
                    lg={5}
                    xl={4}
                    className="d-flex justify-content-center mt-2 mb-2"
                  >
                    <RangePicker
                        ranges={{
                          Today: [moment(), moment()],
                          'This Month': [
                            moment().startOf('month'),
                            moment().endOf('month'),
                          ],
                        }}
                        value={Search.Date}
                        onChange={(date) => setSearch({...Search, Date: date})}
                        suffixIcon={<img src={CALENDAR} />}
                        separator="-"
                        className="calendar-antd-dashboard"
                        style={{
                          boxShadow: 'none ',
                          height: '50px',
                        }}
                      />
                  </Col>
                  <Col
                    lg={5}
                    xl={4}
                    className="d-flex justify-content-center mt-2 mb-2"
                  >
                    <Button type="button" className="button" onClick={() => ExportExcel()}>
                      Export
                    </Button>
                  </Col>
                  
                </Row>

                <Row className="g-0 justify-content-center mt-3 m-0">
                  <Col className="set-table p-0">
                    <table className="table table-responsive table-wash-part ">
                      <thead>
                        <tr className="t-header-package">
                          <th>วันรับบริการ</th>
                          <th>เลขที่ JOB</th>
                          <th>เลขที่บิล</th>
                          <th>รายการ</th>
                          <th>จำนวนเงิน (บาท)</th>
                          <th>รับประกัน</th>
                          <th>สถานะประกัน</th>
                        </tr>
                      </thead>
                      <tbody className="t-body-package ">
                        {
                          ReportStock?.map((item,index) => {
                            return(
                              <tr key={item.id}>
                                <td>{ moment(item.created_at).format('YYYY-MM-DD')}</td>
                                <td>{ item.job.job_code}</td>
                                <td>{ item?.job.bill?.bill_code}</td>
                                <td>{ item?.package?.name}</td>
                                <td>{ numeral(item.job.total_price).format('0,0.00')}</td>
                                <td>{ item.package.warranty_period !== null ? CallWarrantyPeriod(item.created_at, item.package.warranty_period) : '-' }</td>
                                <td>{ item.package.warranty_period !== null ? StatusWarrantyPeriod(item.created_at, item.package.warranty_period) : '-'}</td>
                              </tr> 
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </Col>
                </Row>

                <Row className="g-0 mt-5 ">
            <Col lg={4} className=" set-page">
              <Row>
                <Col className="d-flex justify-content-center align-items-center">
                  <p style={{ margin: 0 }}>แสดง</p>
                </Col>
                <Col lg={7}>
                  <Select
                    className="text-left select-style"
                    aria-label="Default select example"
                    options={Pages}
                    onChange={(data) => setSearch({ ...Search, PerPage: data.value })}
                    defaultValue={{ value: 10, label: '10' }}
                  />
                </Col>
                <Col className="d-flex justify-content-center align-items-center">
                  <p style={{ margin: 0 }}>รายการ</p>
                </Col>
              </Row>
            </Col>

            <Col className="d-flex justify-content-end set-paginate">
              <div className="box-paginate">
                {
                  !Loading ? 
                    Search.Rows > 1 && Search.PerPage > 0 ?
                      <MyPagination totPages={Search.Rows} currentPage={Search.CurrentPage} pageClicked={(e) => { setSearch({...Search, CurrentPage: e }) }}></MyPagination> 
                    : ''
                  : 
                    Search.Rows > 1 && Search.PerPage > 0 ?
                      <MyPagination totPages={Search.Rows} currentPage={Search.CurrentPage} pageClicked={(e) => { setSearch({...Search, CurrentPage: e }) }}></MyPagination> 
                    : ''
                }
              </div>
            </Col>
          </Row>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
